<p-dialog 
  [(visible)]="visible" 
  [modal]="true" 
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{width: '90vw', maxWidth: '900px'}"
  styleClass="accountant-welcome-dialog"
  (onHide)="closeModal()">
  
  <div class="accountant-modal-content" [attr.dir]="curentLang === 'ar' || curentLang === 'he' ? 'rtl' : 'ltr'">
    <!-- Close Button -->
    <button class="close-icon" (click)="closeModal()" aria-label="Close">
      <i class="fa fa-times"></i>
    </button>

    <!-- Modal Header -->
    <div class="modal-header-content">
      <h2 class="modal-title">
        {{ curentLang === 'ar' ? 'موقع جديد للمحاسبين- ادارة اسهل وتقارير محسنة' : (curentLang === 'en' ? 'New Site for Accountants - Easier Management and Enhanced Reports' : 'אתר חדש למייצגים – ניהול נוח יותר ודוחות משודרגים') }}
      </h2>
    </div>

    <!-- Image Container -->
    <div class="modal-image-container">
      <img src="assets/modal.jpeg" alt="Accountant System" class="modal-image" />
    </div>

    <!-- Actions -->
    <div class="modal-actions">
      <div class="action-buttons">
        <button class="btn-primary" (click)="goToAccountantSystem()">
          {{ curentLang === 'ar' ? 'انتقل للموقع الجديد' : (curentLang === 'en' ? 'Go to New Site' : 'לעבור לאתר החדש') }}
        </button>
      </div>
      
      <div class="checkbox-container">
        <input 
          type="checkbox" 
          id="dontShowAgain" 
          [(ngModel)]="dontShowAgain"
          (change)="onCheckboxChange($event)">
        <label for="dontShowAgain">
          {{ curentLang === 'ar' ? 'لا تظهر لي الخيار مجدداً' : (curentLang === 'en' ? 'Don\'t show this message again' : 'אל תציג הודעה זאת שוב') }}
        </label>
      </div>
    </div>
  </div>
</p-dialog>
